import React, { useContext, useState } from 'react'
import { Grid, Typography, TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Context } from '../../../Store'
import { ErrorMessage } from './ErrorMessage'

export const AboutYourself = () => {
  const [state, dispatch] = useContext(Context)
  const [aboutYourself, setAboutYourself] = useState(state?.about_yourself)
  const { t } = useTranslation()

  const onChangeAboutYourself = (event) => {
    dispatch({ type: 'SET_ABOUT_YOURSELF', payload: event.target.value })
    setAboutYourself(event.target.value)
  }

  return (
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('booking.userInfo.message.title')}</Typography>
        <TextField
          name="about_yourself"
          value={aboutYourself}
          onChange={onChangeAboutYourself}
          variant="outlined"
          placeholder={t('booking.userInfo.message.placeholder')}
          rows={4}
          error={state?.error?.about_yourself}
          fullWidth
          multiline
        />
      {state?.error?.about_yourself && <ErrorMessage error={state?.error?.about_yourself} />}
    </Grid>
  )
}